import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import TemplatesIndex from './TemplatesIndex.vue';
import CatalogIndex from './CatalogIndex.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/whatsapp'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'whatsapp_settings_index',
          redirect: to => ({
            name: 'whatsapp_templates_index',
            params: to.params,
          }),
        },
        {
          path: 'templates',
          name: 'whatsapp_templates_index',
          meta: {
            permissions: ['administrator'],
          },
          component: TemplatesIndex,
        },
        {
          path: 'catalog',
          name: 'whatsapp_catalog_index',
          meta: {
            permissions: ['administrator'],
          },
          component: CatalogIndex,
        },
      ],
    },
  ],
};
